/** Merchant-facing order lifecycle. API keys 1,3,6,7,9 not in enum. Key 2 = NEW (backend may still send status.value `PENDING`). */
export enum OrderStatusEnum {
  NEW = 2,
  PREPARING = 4,
  READY = 5,
  CANCELLED = 8,
  /** Fulfilled; payment on payment screen. */
  COMPLETED = 10,
}
